import React from 'react'
import styled from 'styled-components'
import ButtonShell from 'components/elements/Buttons/ButtonShell'

const StyledButton = styled.span`
  display: inline-flex;
  border-radius: 50px;

  & > a,
  & > button {
    color: ${(props) => props.theme.color.secondary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    padding: 0.5rem 1rem;
    display: inline-flex;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    text-decoration: none !important;
    transition: all 0.3s ease;
    border-radius: 50px;

    &:hover {
      color: ${(props) => props.theme.color.secondary};
      box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    }
    @media (min-width: 992px) {
      font-size: ${(props) => props.theme.font.size.medium};
      line-height: ${(props) => props.theme.font.size.large};
      white-space: nowrap;
    }
    @media (max-width: 991px) {
      padding: 10px 45px 10px 20px;
      font-size: ${(props) => props.theme.font.size.small};
      line-height: ${(props) => props.theme.font.size.medium};
    }
  }
`

interface ButtonTransparentArrowProps {
  isAnchor?: boolean
  isCustom?: boolean
  hasArrow?: boolean
  to: string
  children: any
  className?: string
}

const ButtonTransparentArrow: React.FC<ButtonTransparentArrowProps> = ({
  isAnchor = false,
  isCustom = false,
  // hasArrow = false,
  to,
  children,
  className = '',
}) => (
  <StyledButton className={className}>
    {isCustom ? (
      children
    ) : (
      <ButtonShell to={to} isAnchor={isAnchor}>
        {children}
        <Arrow />
      </ButtonShell>
    )}
  </StyledButton>
)

const StyledArrow = styled.div`
  background-color: ${(props) => props.theme.color.secondary};
  position: relative;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  & svg {
    width: 18px;
    height: 18px;
  }
`

export const Arrow = () => (
  <StyledArrow className="ml-4 p-2">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="19"
      viewBox="0 0 13 19"
    >
      <path
        id="Stroke_3"
        data-name="Stroke 3"
        d="M0,0V17L11,8.5Z"
        transform="translate(1 1)"
        fill="none"
        stroke="#ffffff"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="2"
      />
    </svg>
  </StyledArrow>
)

export default ButtonTransparentArrow
